/**
 * ThemeToggle — platform-ops only. Toggles dark/light mode.
 * Adds/removes the `dark` class on <html> and persists to localStorage.
 */

import { useState, useEffect } from 'react';
import { Moon, Sun } from 'lucide-react';
import { useAuth } from '../../providers/AuthProvider';

const STORAGE_KEY = 'apex_theme';

export function ThemeToggle() {
  const { user } = useAuth();
  const [dark, setDark] = useState(false);

  // Only platform-ops can use this
  if (!user?.platformOps) return null;

  // Initialize from localStorage on mount
  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'dark') {
      document.documentElement.classList.add('dark');
      setDark(true);
    } else {
      document.documentElement.classList.remove('dark');
      setDark(false);
    }
  }, []);

  const toggle = () => {
    const next = !dark;
    setDark(next);
    if (next) {
      document.documentElement.classList.add('dark');
      localStorage.setItem(STORAGE_KEY, 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem(STORAGE_KEY, 'light');
    }
  };

  return (
    <button
      onClick={toggle}
      className="flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-[0.6875rem] font-medium border transition-colors cursor-pointer bg-secondary/30 border-border/60 text-muted-foreground hover:text-foreground"
      title={dark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {dark ? <Sun className="w-3 h-3 stroke-[1.5]" /> : <Moon className="w-3 h-3 stroke-[1.5]" />}
      {dark ? 'Light' : 'Dark'}
    </button>
  );
}
